import { useTranslation } from "react-i18next";

const DuplicateModalFooter = ({ onClear, disabled, btnText }) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <footer>
      <button
        data-button-type="secondary"
        className="text-(--danger)!"
        onClick={onClear}
      >
        {t("duplicateModalFooter.clearAll")}
      </button>
      <button type="submit" data-button-type="primary" disabled={disabled}>
        {btnText ?? t("duplicateModalFooter.duplicate")}
      </button>
    </footer>
  );
};

export default DuplicateModalFooter;
